import React from 'react';

import Skeleton from 'flow/components/ui-components/Skeleton';

/** Stands in for a chat row while the first fetch is still out. It borrows the
 *  row's own geometry - BaseListItem's padding and gap, and the avatar at the
 *  size ChatAvatar draws it - so the chats settle into place rather than
 *  shifting sideways as they arrive.
 *
 *  Round, where a room's avatar is a rounded square: the list holds both, and
 *  a circle is the one that reads as an avatar waiting to arrive.
 *
 *  Composed from the Skeleton parts rather than wrapped in Skeleton itself,
 *  whose gap is wider than a list row's. */
const ChatSessionSkeletonItem = () => (
    <div className="animate-fade flex w-full items-center gap-x-3 p-2 text-gray-200">
        <Skeleton.Avatar className="size-10 shrink-0 rounded-full" />

        <div className="flex w-full flex-col gap-y-2">
            <Skeleton.Title className="w-2/5" />
            <Skeleton.Text className="w-4/5" />
        </div>
    </div>
);

export default React.memo(ChatSessionSkeletonItem);
